export const AVATAR_API_URL      = 'avatar.eyespy360.com';
export const AVATAR_API_URL_DEV4 = 'avatar-test.eyespy360.com';

export function getAvatarDomain() {
    return window.location.host.match(/dev4/) ? AVATAR_API_URL_DEV4 : AVATAR_API_URL;
}

// One id per page load, sent as X-Visitor-Id on every tour-viewer request to
// the avatar backend so it rate-limits per visitor instead of per IP (venues
// put every visitor behind one Wi-Fi IP). Must match ^[A-Za-z0-9_-]{8,64}$.
// Only for getAvatarDomain() hosts — never send it to OpenAI, LiveKit, S3 etc.
// (it also makes the request non-simple CORS, which the avatar backend allows).
let _visitorId = null;

export function getVisitorId() {
    if (_visitorId) return _visitorId;
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            _visitorId = crypto.randomUUID().replace(/-/g, '');
        }
    } catch (_) { /* insecure context etc. — fall through */ }
    if (!_visitorId) {
        let id = '';
        while (id.length < 32) id += Math.random().toString(36).slice(2);
        _visitorId = id.slice(0, 32);
    }
    return _visitorId;
}

/** Headers for a request to the avatar backend, merged with `extra`. */
export function avatarHeaders(extra = {}) {
    return Object.assign({ 'X-Visitor-Id': getVisitorId() }, extra);
}
